import { generateURL } from 'utils/helpers';
import { apiSlice } from '.';

apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    bookings: builder.query({
      query: (args) => generateURL('/bookings', args),
      providesTags: ['booking'],
      keepUnusedDataFor: 3600,
    }),
    recreateBooking: builder.query({
      query: (args) =>
        generateURL(`/booking/rebuild?json=${encodeURIComponent(args)}`),
      providesTags: ['booking'],
      keepUnusedDataFor: 3600,
    }),
    updateBooking: builder.mutation({
      query: (args) => ({
        url: generateURL('/booking/update'),
        method: 'PUT',
        body: args,
      }),
    }),
    promoCode: builder.mutation({
      query: (args) => ({
        url: generateURL('/booking/promo_code'),
        method: 'PUT',
        body: args,
      }),
      invalidatesTags: ['/reservation/scheduled_trips/find'],
    }),
    searchBooking: builder.query({
      query: (bookingReference) =>
        generateURL(`/booking/reference/${bookingReference}`),
      providesTags: ['booking'],
      keepUnusedDataFor: 3600,
    }),
    getDraft: builder.query({
      query: (bookingId) => generateURL(`/booking/${bookingId}/draft`),
      providesTags: ['booking'],
      keepUnusedDataFor: 3600,
    }),
    getDraftChanges: builder.query({
      query: (bookingId) => generateURL(`/booking/${bookingId}/draft/changes`),
      providesTags: ['draftChanges'],
      keepUnusedDataFor: 3600,
    }),
    applyDraftChanges: builder.mutation({
      query: (args) => ({
        url: generateURL(`/booking/${args.bookingId}/draft`),
        method: 'PUT',
        body: {
          booking_id: args.bookingId,
          fee_proposal_ids: args.feeIds,
        },
      }),
    }),
    discardDraft: builder.mutation({
      query: (bookingId) => ({
        url: generateURL(`/booking/${bookingId}/draft`),
        method: 'DELETE',
      }),
    }),
    draftFee: builder.query({
      query: (bookingId) => generateURL(`/booking/${bookingId}/draft/fee`),
      providesTags: ['draftFee'],
      keepUnusedDataFor: 3600,
    }),
    getBookingCancellationFee: builder.query({
      query: (bookingId) =>
        generateURL(`/booking/${bookingId}/booking_cancellation_fee`),
      providesTags: ['booking', 'booking_cancellation_fee'],
      keepUnusedDataFor: 3600,
    }),
    getBookingCancellationRefundEligibility: builder.query({
      query: (bookingId) => ({
        url: generateURL(
          '/fee_proposals/booking_cancellation_refund_eligibility'
        ),
        method: 'POST',
        body: {
          target_booking_id: bookingId,
        },
      }),
      providesTags: ['booking', 'booking_cancellation_refund_eligibility'],
      keepUnusedDataFor: 3600,
    }),
    cancelBooking: builder.mutation({
      query: ({ bookingId, fees }) => ({
        url: generateURL(`/booking/${bookingId}/cancel`),
        method: 'PUT',
        body: {
          ...(fees && { fees }),
        },
      }),
    }),
  }),
});

export const {
  useBookingsQuery,
  useRecreateBookingQuery,
  useUpdateBookingMutation,
  usePromoCodeMutation,
  useLazySearchBookingQuery,
  useLazyGetDraftQuery,
  useLazyGetDraftChangesQuery,
  useApplyDraftChangesMutation,
  useDiscardDraftMutation,
  useLazyDraftFeeQuery,
  useLazyGetBookingCancellationFeeQuery,
  useLazyGetBookingCancellationRefundEligibilityQuery,
  useCancelBookingMutation,
} = apiSlice;
